export const CreateSheetTestIds = {
  DRAWER: 'create-sheet.drawer',
  BACK: 'create-sheet.back-button',
  CONTINUE_PHOTOS: 'create-sheet.continue-button',
};
